<template>
	<label v-if="label" for="cityDataList" class="form-label small text-dark">{{
		label
	}}</label>
	<textarea
		class="form-control form-control-lg"
		v-bind="$attrs"
		:id="id"
		:value="modelValue"
		:placeholder="label"
		@change="
			$emit('update:modelValue', $event.target.value),
				validate($event.target.value)
		"
	></textarea>
	<span v-if="validationState.error" class="text-danger small">{{
		validationState.message
	}}</span>
</template>
<script>
	import validator from "@/config/validator";
	import { reactive } from "vue";
	export default {
		name: "BaseTextArea",
		props: {
			id: {
				type: [String, Number],
				default: null,
			},
			label: {
				type: String,
				default: null,
			},
			modelValue: {
				type: [String, Number, Array, Function],
				default: null,
			},
			name: {
				type: String,
			},
			rules: {
				type: String,
				default: null,
			},
		},
		setup(props, { emit }) {
			const validationState = reactive({
				error: false,
				field: null,
				message: null,
			});

			const setState = function (data = false) {
				validationState.error = data.val || false;
				validationState.message = data.message || null;
				validationState.field = data.name || null;
			};

			const validate = async function (value) {
				if (!props.rules)
					return emit("valSuccess", { error: false, field: props.name });
				try {
					let result = await validator.validateForm(
						props.name,
						props.rules,
						value,
					);
					if (!result.success) {
						setState({
							val: true,
							message: result?.message,
							name: result?.field_name,
						});
						emit("valError", { error: true, field: result?.field_name });
						return;
					}
					setState();
					emit("valSuccess", { error: false, field: result?.field_name });
					return;
				} catch (err) {
					console.log(err);
				}
				return;
			};

			return {
				validate,
				validationState,
			};
		},
	};
</script>
<style scoped>
textarea::placeholder {
		color: #999;
		font-size: 13px;
	}
textarea.form-control.form-control-lg {
    border: 1px solid #F4BB22;
	background: #f4bc220d;
}
label.form-label.small.text-dark {
    color: #F4BB22 !important;
    font-size: 20px;
}
</style>

